import client from './client';

export const ingredientsApi = {
  getAll: () => client.get('/ingredients')
};
